<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell *ngIf="caseItem">

  <app-page-detail-hero [auditStamp]="caseItem"
    icon="pi pi-box"
    eyebrow="Lifecycle Case"
    [title]="caseItem.caseNumber || caseItem.containerNumber || 'Container Case'"
    [subtitle]="(caseItem.containerNumber || 'No container') + ' | ' + (caseItem.billOfLadingNumber || 'No BL')">
    <div tags>
      <p-tag [value]="caseItem.status || '-'" [severity]="statusSeverity(caseItem.status)"></p-tag>
      <p-tag [value]="caseItem.currentState || 'No state'" severity="info"></p-tag>
      <p-tag [value]="'Risk: ' + riskBadge" [severity]="riskSeverity(riskBadge)"></p-tag>
      <p-tag *ngIf="hasLogisticsProject()" [value]="projectContextLabel()" severity="contrast"></p-tag>
    </div>
    <div actions>
      <p-button *ngIf="commercialWorkspaceReference()" [label]="commercialWorkspaceLabel()" icon="pi pi-briefcase"
        severity="secondary" [outlined]="true" (click)="openCommercialWorkspace()"></p-button>
      <p-button *ngIf="hasLogisticsProject()" label="Open Project" icon="pi pi-sitemap" severity="secondary" [outlined]="true" (click)="openProject()"></p-button>
      <p-button *ngIf="canManageLegs" label="Plan Journey" icon="pi pi-directions" severity="secondary" [outlined]="true" (click)="openJourneyPlanner()" [loading]="isSubmitting"></p-button>
      <p-button *ngIf="canManageStorage" label="Add Storage Leg" icon="pi pi-plus" severity="secondary" [outlined]="true" (click)="openAddStorageDialog()"></p-button>
      <p-button *ngIf="canManageStorage" label="Gate In" icon="pi pi-sign-in" severity="secondary" [outlined]="true" (click)="openYardGateInDialog()"></p-button>
      <p-button *ngIf="canEditCase && caseItem.status !== 'COMPLETED'" label="Close Case" icon="pi pi-check-circle" (click)="closeCase()"></p-button>
    </div>
  </app-page-detail-hero>

  <p-tabs [value]="activeTabValue" (valueChange)="onTabChange($event)" styleClass="case-workspace-tabs">
    <p-tablist>
      <p-tab [value]="0">
        <span class="workspace-tab">
          <i class="pi pi-th-large"></i>
          <span>Overview</span>
        </span>
      </p-tab>
      <p-tab [value]="1">
        <span class="workspace-tab">
          <i class="pi pi-history"></i>
          <span>Timeline</span>
          <p-badge [value]="timeline.length.toString()" severity="info"></p-badge>
        </span>
      </p-tab>
      <p-tab [value]="7">
        <span class="workspace-tab">
          <i class="pi pi-directions"></i>
          <span>Journey Plan</span>
          <p-badge [value]="journeyItems().length.toString()" [severity]="journeyItems().length ? 'info' : 'secondary'"></p-badge>
        </span>
      </p-tab>
      <p-tab [value]="2">
        <span class="workspace-tab">
          <i class="pi pi-truck"></i>
          <span>Transport Legs</span>
          <p-badge [value]="transportContextCount().toString()" [severity]="transportContextCount() ? 'success' : 'secondary'"></p-badge>
        </span>
      </p-tab>
      <p-tab [value]="3">
        <span class="workspace-tab">
          <i class="pi pi-shield"></i>
          <span>Clearance</span>
          <p-badge [value]="clearanceEvents.length.toString()" [severity]="clearanceEvents.length ? 'success' : 'secondary'"></p-badge>
        </span>
      </p-tab>
      <p-tab [value]="4">
        <span class="workspace-tab">
          <i class="pi pi-warehouse"></i>
          <span>Storage Legs</span>
          <p-badge [value]="storageLegs.length.toString()" [severity]="storageLegs.length ? 'success' : 'secondary'"></p-badge>
        </span>
      </p-tab>
      <p-tab [value]="5">
        <span class="workspace-tab">
          <i class="pi pi-arrows-h"></i>
          <span>Handoffs</span>
          <p-badge [value]="handoffs.length.toString()" [severity]="blockedHandoffCount() ? 'danger' : (handoffs.length ? 'info' : 'secondary')"></p-badge>
        </span>
      </p-tab>
      <p-tab [value]="6">
        <span class="workspace-tab">
          <i class="pi pi-exclamation-triangle"></i>
          <span>Readiness & Exceptions</span>
          <p-badge [value]="exceptions.length.toString()" [severity]="exceptions.length ? 'warn' : 'success'"></p-badge>
        </span>
      </p-tab>
      <p-tab [value]="8">
        <span class="workspace-tab">
          <i class="pi pi-link"></i>
          <span>Linked Records</span>
          <p-badge [value]="links.length.toString()" [severity]="links.length ? 'info' : 'secondary'"></p-badge>
        </span>
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <section class="workspace-section overview-workspace">
          <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

          <app-page-data-panel title="Container Overview" subtitle="Lifecycle envelope, reference numbers, active controls, and audit context." resultText="Case summary">
            <div class="overview-grid">
              <div class="overview-card">
                <span>Container</span>
                <strong>{{ caseItem.containerNumber || '-' }}</strong>
                <small>{{ caseItem.isoEquipmentType || 'Equipment type pending' }}</small>
              </div>
              <div class="overview-card">
                <span>BL / Booking</span>
                <strong>{{ caseItem.billOfLadingNumber || '-' }}</strong>
                <small>{{ caseItem.bookingNumber || 'Booking not captured' }}</small>
              </div>
              <div class="overview-card">
                <span>Seal / House BL</span>
                <strong>{{ caseItem.sealNumber || '-' }}</strong>
                <small>{{ caseItem.houseBillNumber || 'House BL not captured' }}</small>
              </div>
              <div class="overview-card">
                <span>Customs</span>
                <strong>{{ caseItem.customsDeclarationNumber || '-' }}</strong>
                <small>{{ clearanceGateDetail() }}</small>
              </div>
              <div class="overview-card">
                <span>Customer Context</span>
                <strong>{{ customerContextLabel() }}</strong>
                <small>{{ crmContextLabel() }}</small>
              </div>
              <div class="overview-card">
                <span>Lifecycle Dates</span>
                <strong>{{ dateTimeLabel(caseItem.openedAt || caseItem.createdAt) }}</strong>
                <small>{{ caseItem.closedAt ? ('Closed ' + dateTimeLabel(caseItem.closedAt)) : 'Open lifecycle' }}</small>
              </div>
            </div>
          </app-page-data-panel>

          <div class="case-inline-note" *ngIf="etaDetail">{{ etaDetail }}</div>

          <section class="orchestration-strip" aria-label="Container lifecycle orchestration">
            <div class="orchestration-header">
              <div>
                <span>Lifecycle Orchestration</span>
                <strong>Transport, storage, yard, and handoff control</strong>
              </div>
              <div class="orchestration-actions">
                <p-button icon="pi pi-refresh" label="Reconcile" severity="info" [outlined]="true" size="small" (click)="reconcileHandoffs()" [loading]="isSubmitting"></p-button>
                <p-button *ngIf="canManageStorage" icon="pi pi-sign-in" label="Gate In" severity="secondary" [outlined]="true" size="small" (click)="openYardGateInDialog()"></p-button>
              </div>
            </div>

            <div class="orchestration-grid">
              <button type="button" class="orchestration-card" (click)="onTabChange(2)">
                <span class="orchestration-card-icon transport"><i class="pi pi-truck"></i></span>
                <span class="orchestration-card-body">
                  <span>Active Transport</span>
                  <strong>{{ activeTransportLeg() ? transportLegLabel(activeTransportLeg()?.id) : 'No active transport' }}</strong>
                  <small>{{ activeTransportDetail() }}</small>
                </span>
                <p-tag [value]="activeTransportLeg()?.status || 'NONE'" [severity]="statusSeverity(activeTransportLeg()?.status)"></p-tag>
              </button>

              <button type="button" class="orchestration-card" (click)="onTabChange(4)">
                <span class="orchestration-card-icon storage"><i class="pi pi-warehouse"></i></span>
                <span class="orchestration-card-body">
                  <span>Active Storage</span>
                  <strong>{{ activeStorageLeg() ? storageLegLabel(activeStorageLeg()?.id) : 'No active storage' }}</strong>
                  <small>{{ activeStorageDetail() }}</small>
                </span>
                <p-tag [value]="activeStorageLeg()?.status || 'NONE'" [severity]="statusSeverity(activeStorageLeg()?.status)"></p-tag>
              </button>

              <button type="button" class="orchestration-card" (click)="onTabChange(4)">
                <span class="orchestration-card-icon yard"><i class="pi pi-sitemap"></i></span>
                <span class="orchestration-card-body">
                  <span>Active Yard Visit</span>
                  <strong>{{ activeYardVisitLabel() }}</strong>
                  <small>{{ activeYardVisitDetail() }}</small>
                </span>
                <p-tag [value]="activeYardVisit()?.status || 'NONE'" [severity]="statusSeverity(activeYardVisit()?.status)"></p-tag>
              </button>

              <button type="button" class="orchestration-card" (click)="onTabChange(5)">
                <span class="orchestration-card-icon handoff"><i class="pi pi-arrows-h"></i></span>
                <span class="orchestration-card-body">
                  <span>Next Handoff</span>
                  <strong>{{ nextHandoffLabel() }}</strong>
                  <small>{{ nextHandoffDetail() }}</small>
                </span>
                <p-tag [value]="nextRequiredHandoff()?.status || 'NONE'" [severity]="statusSeverity(nextRequiredHandoff()?.status)"></p-tag>
              </button>

              <button type="button" class="orchestration-card exception" (click)="onTabChange(5)">
                <span class="orchestration-card-icon exception"><i class="pi pi-ban"></i></span>
                <span class="orchestration-card-body">
                  <span>Blocked Handoffs</span>
                  <strong>{{ blockedHandoffCount() }}</strong>
                  <small>{{ blockedHandoffDetail() }}</small>
                </span>
                <p-tag [value]="blockedHandoffCount() ? 'BLOCKED' : 'CLEAR'" [severity]="blockedHandoffCount() ? 'danger' : 'success'"></p-tag>
              </button>
            </div>
          </section>

        </section>
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <section class="workspace-section">
          <app-page-data-panel title="Movement Timeline" subtitle="Container journey in GCC operations language: empty pickup, gate-out, yard in, destuff, dispatch, and empty return." [resultText]="timeline.length + ' events'">
            <div class="dispatch-board case-stage-board">
              <div>
                <span>Movement Stage</span>
                <strong>{{ movementStageLabel(caseItem.currentState) }}</strong>
                <small>{{ movementStageDetail(caseItem.currentState) }}</small>
              </div>
              <div>
                <span>Next Checkpoint</span>
                <strong>{{ etaLabel }}</strong>
                <small>{{ etaDetail || 'No projected checkpoint is available yet.' }}</small>
              </div>
              <div>
                <span>Road Legs</span>
                <strong>{{ transportLegs.length }}</strong>
                <small>{{ countTransportByStatus('ACTIVE') }} active | {{ countTransportByStatus('COMPLETED') }} complete</small>
              </div>
              <div>
                <span>Storage Legs</span>
                <strong>{{ storageLegs.length }}</strong>
                <small>{{ countStorageByStatus('ACTIVE') }} active | {{ countStorageByStatus('COMPLETED') }} complete</small>
              </div>
              <div>
                <span>Clearance Gate</span>
                <strong>{{ clearanceGateLabel() }}</strong>
                <small>{{ clearanceGateDetail() }}</small>
              </div>
              <div>
                <span>Next Handoff</span>
                <strong>{{ nextRequiredHandoff() ? handoffTypeLabel(nextRequiredHandoff()?.handoffType) : 'None' }}</strong>
                <small>{{ nextRequiredHandoff()?.status || 'No open handoff' }}</small>
              </div>
            </div>

            <div class="timeline-day-list" *ngIf="timelineGroups.length; else emptyTimeline">
              <section class="timeline-day-card" *ngFor="let group of timelineGroups">
                <div class="timeline-day-header">
                  <div>
                    <h3>{{ group.label }}</h3>
                    <p>Movement milestones logged on this operating day.</p>
                  </div>
                  <p-tag [value]="group.eventCountLabel" severity="info"></p-tag>
                </div>

                <div class="timeline-event-list">
                  <article class="timeline-event-card" *ngFor="let event of group.events">
                    <div class="timeline-event-time">
                      <strong>{{ timeLabel(event.eventTime || event.createdAt) }}</strong>
                      <span>{{ timelineStageLabel(event) }}</span>
                    </div>

                    <div class="timeline-event-body">
                      <div class="timeline-event-top">
                        <div class="timeline-event-title-stack">
                          <div class="timeline-event-tags">
                            <p-tag [value]="timelineStageLabel(event)" [severity]="timelineStageSeverity(event)"></p-tag>
                            <p-tag [value]="eventSourceLabel(event.sourceModule)" [severity]="eventSeverity(event.sourceModule)"></p-tag>
                            <p-tag [value]="eventLabel(event.eventCode)" [severity]="eventCodeSeverity(event.eventCode)"></p-tag>
                          </div>
                          <strong>{{ eventLabel(event.eventCode) }}</strong>
                          <span>{{ eventLocationLine(event) }}</span>
                        </div>

                        <small class="timeline-reference" *ngIf="eventReferenceLabel(event)">{{ eventReferenceLabel(event) }}</small>
                      </div>

                      <p class="timeline-event-note">{{ eventNote(event) }}</p>

                      <div class="timeline-event-footer">
                        <span>{{ actorLabel(event.actor, event.createdBy) }}</span>
                        <span>{{ event.eventSource || 'MANUAL' }}</span>
                      </div>
                    </div>
                  </article>
                </div>
              </section>
            </div>
          </app-page-data-panel>
        </section>
      </p-tabpanel>

      <p-tabpanel [value]="2">
        <section class="workspace-section">
          <app-page-data-panel title="Transport Planning & Execution" subtitle="Confirmed transport steps awaiting shipment and shipment-backed execution legs for this container lifecycle." [resultText]="transportContextCount() + ' records'">
            <div class="dispatch-board case-leg-board">
              <div>
                <span>Total Records</span>
                <strong>{{ transportContextCount() }}</strong>
                <small>ready steps and execution legs</small>
              </div>
              <div>
                <span>Awaiting Shipment</span>
                <strong>{{ journeyPendingTransportReleases().length }}</strong>
                <small>confirmed transport steps</small>
              </div>
              <div>
                <span>Active</span>
                <strong>{{ countTransportByStatus('ACTIVE') }}</strong>
                <small>active execution</small>
              </div>
              <div>
                <span>Completed</span>
                <strong>{{ countTransportByStatus('COMPLETED') }}</strong>
                <small>execution closed</small>
              </div>
            </div>

            <div class="execution-card-list" *ngIf="transportContextCount(); else emptyTransportLegs">
              <article class="execution-card planned-release-card" *ngFor="let item of journeyPendingTransportReleases()">
                <div class="execution-header">
                  <div class="execution-identity">
                    <span class="job-label">Planned transport step {{ item.sequenceNo || '-' }}</span>
                    <strong>{{ item.stepName || transportModeLabel(item.transportMode) }}</strong>
                    <small>{{ item.transportOrderReleaseId ? 'Managed by Transport Planning' : 'Ready for grouped shipment' }}</small>
                  </div>
                  <div class="execution-status">
                    <p-tag [value]="item.status || 'AWAITING_SHIPMENT'" severity="info"></p-tag>
                    <span>{{ item.transportOrderReleaseId ? 'Order release created' : 'Ready for dispatch' }}</span>
                  </div>
                </div>

                <div class="execution-route">
                  <i class="pi pi-map-marker"></i>
                  <span>{{ item.originLocationText || 'Origin pending' }}</span>
                  <i class="pi pi-arrow-right"></i>
                  <span>{{ item.destinationLocationText || 'Destination pending' }}</span>
                </div>

                <div class="execution-grid three">
                  <div class="execution-block">
                    <span>Planning Demand</span>
                    <button *ngIf="item.transportOrderReleaseId" type="button" class="journey-downstream-link" (click)="openTransportRelease(item.transportOrderReleaseId)">
                      <strong>{{ journeyReleaseReference(item) }}</strong>
                      <i class="pi pi-external-link"></i>
                    </button>
                    <strong *ngIf="!item.transportOrderReleaseId">Container journey step</strong>
                    <small>{{ item.transportMode || 'Mode pending' }} | {{ item.priority || 'NORMAL' }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Planned Window</span>
                    <strong>{{ dateTimeLabel(item.plannedStartAt) }}</strong>
                    <small>to {{ dateTimeLabel(item.plannedEndAt) }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Execution Status</span>
                    <strong>Awaiting shipment delivery</strong>
                    <small>The execution leg will appear after a shipment is created.</small>
                  </div>
                </div>

                <div class="execution-actions">
                  <p-button *ngIf="item.transportOrderReleaseId" icon="pi pi-external-link" label="Open Release" severity="secondary" [text]="true" (click)="openTransportRelease(item.transportOrderReleaseId)"></p-button>
                  <p-button *ngIf="item.status === 'AWAITING_DISPATCH' && canManageLegs && canCreateShipments" icon="pi pi-truck" label="Create Shipment" (click)="openDispatchDialog(item)"></p-button>
                </div>
              </article>

              <article class="execution-card" *ngFor="let leg of transportLegs">
                <div class="execution-header">
                  <div class="execution-identity">
                    <span class="job-label">Road leg {{ leg.sequenceNo || '-' }}</span>
                    <strong>{{ transportModeLabel(leg.mode) }}</strong>
                    <small>{{ leg.carrierName || vendorLabel(leg.vendorCompanyId) }}</small>
                  </div>

                  <div class="execution-status">
                    <p-tag [value]="leg.status || '-'" [severity]="statusSeverity(leg.status)"></p-tag>
                    <span>{{ transportStatusText(leg) }}</span>
                  </div>
                </div>

                <div class="execution-route">
                  <i class="pi pi-map-marker"></i>
                  <span>{{ leg.fromLocationText || 'Pickup point pending' }}</span>
                  <i class="pi pi-arrow-right"></i>
                  <span>{{ leg.toLocationText || 'Destination pending' }}</span>
                </div>

                <div class="execution-grid three">
                  <div class="execution-block">
                    <span>Ownership</span>
                    <strong>{{ transportOwnershipLabel(leg) }}</strong>
                    <small>{{ transportOwnershipDetail(leg) }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Shipment Context</span>
                    <strong>{{ shipmentContextLabel(leg) }}</strong>
                    <small>{{ shipmentContextDetail(leg) }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Linked Ops</span>
                    <strong>{{ linkedOpsLabel(leg) }}</strong>
                    <small>{{ linkedOpsDetail(leg) }}</small>
                    <p-tag *ngIf="!leg.transportReleaseId" value="Legacy transport record" severity="warn"></p-tag>
                  </div>
                  <div class="execution-block">
                    <span>Storage Handoff</span>
                    <strong>{{ dispatchReadinessLabel(leg) }}</strong>
                    <small>{{ leg.sourceStorageLegId ? storageLegLabel(leg.sourceStorageLegId) : 'No source storage requirement' }}{{ leg.destinationStorageLegId ? ' | To ' + storageLegLabel(leg.destinationStorageLegId) : '' }}</small>
                  </div>
                </div>

                <div class="execution-milestones">
                  <div class="milestone-chip">
                    <span>Pickup</span>
                    <strong>{{ milestoneLabel(leg.actualPickupAt, leg.plannedPickupAt) }}</strong>
                  </div>
                  <div class="milestone-chip">
                    <span>Gate-Out</span>
                    <strong>{{ milestoneLabel(leg.actualDepartureAt, leg.plannedDepartureAt) }}</strong>
                  </div>
                  <div class="milestone-chip">
                    <span>Arrival</span>
                    <strong>{{ milestoneLabel(leg.actualArrivalAt, leg.plannedArrivalAt) }}</strong>
                  </div>
                  <div class="milestone-chip">
                    <span>Delivery</span>
                    <strong>{{ milestoneLabel(leg.actualDeliveryAt, leg.plannedDeliveryAt) }}</strong>
                  </div>
                </div>

                <div class="execution-actions">
                  <p-button *ngIf="leg.transportReleaseId" icon="pi pi-external-link" label="Open Release" severity="secondary" [text]="true" (click)="openTransportRelease(leg.transportReleaseId)"></p-button>
                  <p-button *ngIf="canOpenShipmentDelivery(leg)" icon="pi pi-truck" label="Open Shipment / Delivery" severity="info" [text]="true" (click)="openShipmentDelivery(leg)"></p-button>
                  <p-button *ngIf="shouldShowTransportReconcile(leg)" icon="pi pi-refresh" label="Reconcile" severity="info" [text]="true" (click)="reconcileHandoffs()"></p-button>
                  <p-button *ngIf="canManageLegs && !leg.transportReleaseId" icon="pi pi-exclamation-triangle" label="Mark Tracking Exception" severity="warn" [text]="true" (click)="exceptionTransportLeg(leg)"></p-button>
                </div>
              </article>
            </div>
          </app-page-data-panel>
        </section>
      </p-tabpanel>

      <p-tabpanel [value]="3">
        <div class="detail-grid">
          <app-page-data-panel title="Clearance Readiness" subtitle="Live customs and line-release state for onward land execution." resultText="Live projection">
            <div class="link-grid">
              <div class="link-card">
                <strong>Customs Release</strong>
                <span>{{ readiness?.customsReleaseStatus || (readiness?.customsReleased ? 'RELEASED' : 'PENDING') }}</span>
              </div>
              <div class="link-card">
                <strong>Line Release</strong>
                <span>{{ readiness?.lineStatus || (readiness?.lineReleased ? 'RELEASED' : 'PENDING') }}</span>
              </div>
              <div class="link-card">
                <strong>Inspection</strong>
                <span>{{ readiness?.inspectionStatus || (readiness?.inspectionBlocked ? 'BLOCKED' : 'CLEAR') }}</span>
              </div>
              <div class="link-card">
                <strong>Available</strong>
                <span>{{ readiness?.containerAvailable ? 'Yes' : 'No' }}</span>
              </div>
            </div>
          </app-page-data-panel>

          <app-page-data-panel title="Linked Clearance Records" subtitle="Live typed links and clearance-owned records connected to this case." [resultText]="links.length + ' links'">
            <div class="link-grid">
              <div class="link-card" *ngFor="let link of links">
                <strong>{{ resourceLinkLabel(link) }}</strong>
                <span>{{ linkedRecordReferenceLabel(link) }}</span>
                <div class="link-card-actions">
                  <p-tag [value]="link.status || 'ACTIVE'" severity="info"></p-tag>
                  <p-button *ngIf="link.resourceType === 'PURCHASE_ORDER'" label="Receive against PO" icon="pi pi-sign-in"
                    size="small" severity="success" [text]="true" (click)="receiveAgainstPurchaseOrder(link)"></p-button>
                  <p-button *ngIf="routeForLink(link)" icon="pi pi-external-link" severity="secondary" [text]="true" (click)="navigateToLinkedResource(link)"></p-button>
                </div>
              </div>
            </div>
          </app-page-data-panel>

          <app-page-data-panel title="Clearance Events" subtitle="Lifecycle events emitted by the clearance module." [resultText]="clearanceEvents.length + ' events'">
            <p-table [value]="clearanceEvents" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr><th>Event</th><th>Time</th><th>Reference</th></tr>
              </ng-template>
              <ng-template pTemplate="body" let-event>
                <tr>
                  <td>{{ event.eventCode }}</td>
                  <td>{{ event.eventTime || event.createdAt | date:'short' }}</td>
                  <td>{{ event.sourceReference || event.locationText || '-' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>
        </div>
      </p-tabpanel>

      <p-tabpanel [value]="4">
        <section class="workspace-section">
          <app-page-data-panel title="Yard / Storage Legs" subtitle="Dispatch-style dwell control across bonded yard, CFS, warehouse staging, customer site, and empty depot." [resultText]="storageLegs.length + ' legs'">
            <div class="dispatch-board case-leg-board">
              <div>
                <span>Total Legs</span>
                <strong>{{ storageLegs.length }}</strong>
                <small>storage checkpoints</small>
              </div>
              <div>
                <span>Active Dwell</span>
                <strong>{{ countStorageByStatus('ACTIVE') }}</strong>
                <small>container inside facility</small>
              </div>
              <div>
                <span>Completed</span>
                <strong>{{ countStorageByStatus('COMPLETED') }}</strong>
                <small>yard cycle closed</small>
              </div>
              <div>
                <span>Exceptions</span>
                <strong>{{ countStorageByStatus('EXCEPTION') }}</strong>
                <small>needs release or investigation</small>
              </div>
            </div>

            <div class="execution-card-list" *ngIf="storageLegs.length; else emptyStorageLegs">
              <article class="execution-card storage-card" *ngFor="let leg of storageLegs">
                <div class="execution-header">
                  <div class="execution-identity">
                    <span class="job-label">Storage leg {{ leg.sequenceNo || '-' }}</span>
                    <strong>{{ storageFacilityLabel(leg.facilityType) }}</strong>
                    <small>{{ leg.facilityName || 'Facility name pending' }}</small>
                  </div>

                  <div class="execution-status">
                    <p-tag *ngIf="isReferenceOnlyStorageLeg(leg)" value="Third-party Terminal Reference" severity="warn"></p-tag>
                    <p-tag [value]="leg.status || '-'" [severity]="statusSeverity(leg.status)"></p-tag>
                    <span>{{ storageStatusText(leg) }}</span>
                  </div>
                </div>

                <div class="execution-route storage-route">
                  <i class="pi pi-warehouse"></i>
                  <span>{{ leg.facilityName || 'Storage facility pending' }}</span>
                  <i class="pi pi-angle-right"></i>
                  <span>{{ leg.slotCode ? ('Bay / Slot ' + leg.slotCode) : 'Bay not assigned' }}</span>
                </div>

                <div class="execution-grid three">
                  <div class="execution-block">
                    <span>Facility Type</span>
                    <strong>{{ storageFacilityLabel(leg.facilityType) }}</strong>
                    <small>{{ leg.storageReason || 'No dwell reason recorded' }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Dwell Control</span>
                    <strong>{{ isReferenceOnlyStorageLeg(leg) ? 'External terminal control' : (leg.slotCode || 'Slot pending') }}</strong>
                    <small>{{ isReferenceOnlyStorageLeg(leg) ? supplierOperatorLabel(leg.operatorCrmClientId) : (leg.notes || 'No storage notes recorded') }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Free Time</span>
                    <strong>{{ isReferenceOnlyStorageLeg(leg) ? 'Not managed' : (leg.freeTimeEndAt ? dateTimeLabel(leg.freeTimeEndAt) : 'Not captured') }}</strong>
                    <small>{{ isReferenceOnlyStorageLeg(leg) ? 'Charges and free time remain with supplier terminal.' : (leg.chargeableFromAt ? ('Chargeable from ' + dateTimeLabel(leg.chargeableFromAt)) : 'Chargeability not set') }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Lifecycle Bridge</span>
                    <strong>{{ storageBridgeLabel(leg) }}</strong>
                    <small>{{ storageBridgeDetail(leg) }}</small>
                  </div>
                </div>

                <div class="execution-milestones">
                  <div class="milestone-chip">
                    <span>Yard In</span>
                    <strong>{{ milestoneLabel(leg.actualInAt, leg.plannedInAt) }}</strong>
                  </div>
                  <div class="milestone-chip">
                    <span>Chargeable From</span>
                    <strong>{{ leg.chargeableFromAt ? dateTimeLabel(leg.chargeableFromAt) : 'Pending' }}</strong>
                  </div>
                  <div class="milestone-chip">
                    <span>Planned Out</span>
                    <strong>{{ leg.plannedOutAt ? dateTimeLabel(leg.plannedOutAt) : 'Pending' }}</strong>
                  </div>
                  <div class="milestone-chip">
                    <span>Yard Out</span>
                    <strong>{{ leg.actualOutAt ? dateTimeLabel(leg.actualOutAt) : 'Pending' }}</strong>
                  </div>
                </div>

                <div class="execution-actions">
                  <ng-container *ngIf="!isReferenceOnlyStorageLeg(leg)">
                    <p-button icon="pi pi-external-link" label="Open Storage Control" severity="secondary" [text]="true" (click)="openStorageControl(leg)"></p-button>
                    <p-button *ngIf="canManageStorage && isStorageLegPlanned(leg)" icon="pi pi-sign-in" label="Receive" severity="success" [text]="true" (click)="receiveStorageLeg(leg)"></p-button>
                    <p-button *ngIf="canManageStorage && isStorageLegActive(leg)" icon="pi pi-table" label="Slot" severity="info" [text]="true" (click)="slotStorageLeg(leg)"></p-button>
                    <p-button *ngIf="canManageStorage && isStorageLegActive(leg) && !isStorageLegOnHold(leg)" icon="pi pi-lock" label="Hold" severity="warn" [text]="true" (click)="holdStorageLeg(leg)"></p-button>
                    <p-button *ngIf="canManageStorage && isStorageLegOnHold(leg)" icon="pi pi-lock-open" label="Release" severity="success" [text]="true" (click)="releaseStorageLeg(leg)"></p-button>
                    <p-button *ngIf="canManageStorage && isStorageLegActive(leg)" icon="pi pi-sign-out" label="Exit" severity="danger" [text]="true" (click)="exitStorageLeg(leg)"></p-button>
                  </ng-container>
                </div>
              </article>
            </div>
            <div class="execution-card-list yard-visit-list" *ngIf="yardVisits.length">
              <article class="execution-card yard-visit-card" *ngFor="let visit of yardVisits">
                <div class="execution-header">
                  <div class="execution-identity">
                    <span class="job-label">Yard visit {{ visit.id || '-' }}</span>
                    <strong>{{ facilityLabel(visit.facilityId) }}</strong>
                    <small>{{ visit.containerNumber || caseItem.containerNumber }} | {{ visit.visitType || 'TERMINAL_YARD' }}</small>
                  </div>
                  <div class="execution-status">
                    <p-tag [value]="visit.status || '-'" [severity]="statusSeverity(visit.status)"></p-tag>
                    <span>{{ visit.holdActive ? (visit.holdReason || 'Hold active') : (visit.currentLocationText || 'Terminal yard ledger') }}</span>
                  </div>
                </div>

                <div class="execution-grid three">
                  <div class="execution-block">
                    <span>Current Location</span>
                    <strong>{{ yardSlotLabel(visit.currentSlotId, visit.currentLocationText) }}</strong>
                    <small>{{ yardAreaLabel(visit.currentAreaId) }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Storage Link</span>
                    <strong>{{ storageLegLabel(visit.storageLegId) }}</strong>
                    <small>{{ visit.freeTimeEndAt ? ('Free time until ' + dateTimeLabel(visit.freeTimeEndAt)) : 'Free-time not captured' }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Gate Window</span>
                    <strong>{{ visit.gateInAt ? dateTimeLabel(visit.gateInAt) : 'Gate-in pending' }}</strong>
                    <small>{{ visit.gateOutAt ? ('Out ' + dateTimeLabel(visit.gateOutAt)) : 'Still in yard' }}</small>
                  </div>
                </div>

                <div class="execution-grid three">
                  <div class="execution-block">
                    <span>Inventory</span>
                    <strong>{{ visit.emptyFullStatus || 'UNKNOWN' }}</strong>
                    <small>{{ visit.dwellDays || 0 }} dwell days, {{ visit.chargeableDays || 0 }} chargeable</small>
                  </div>
                  <div class="execution-block">
                    <span>Seal / Condition</span>
                    <strong>{{ visit.sealVerified === false ? 'Seal mismatch' : 'Seal verified' }}</strong>
                    <small>{{ visit.conditionStatus || 'UNKNOWN' }}{{ visit.damageObserved ? ' | Damage noted' : '' }}</small>
                  </div>
                  <div class="execution-block">
                    <span>Estimated Yard Charges</span>
                    <strong>{{ yardVisitChargeTotal(visit.id) }}</strong>
                    <small>{{ latestYardEir(visit.id)?.eirNumber || 'EIR not available yet' }}</small>
                  </div>
                </div>

                <p-table [value]="yardVisitMoves(visit.id)" styleClass="p-datatable-sm yard-move-table">
                  <ng-template pTemplate="header"><tr><th>Move</th><th>Time</th><th>From</th><th>To</th><th>Reference</th></tr></ng-template>
                  <ng-template pTemplate="body" let-move>
                    <tr>
                      <td>{{ eventLabel(move.moveType) }}</td>
                      <td>{{ dateTimeLabel(move.eventTime) }}</td>
                      <td>{{ yardSlotLabel(move.fromSlotId) }}</td>
                      <td>{{ yardSlotLabel(move.toSlotId) }}</td>
                      <td>{{ move.referenceNumber || move.remarks || '-' }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr><td colspan="5"><div class="table-empty">No yard moves recorded for this visit.</div></td></tr>
                  </ng-template>
                </p-table>

                <div class="execution-actions">
                  <p-button icon="pi pi-file-pdf" label="View EIR" severity="secondary" [text]="true" [disabled]="!latestYardEir(visit.id)" (click)="openYardEir(latestYardEir(visit.id))"></p-button>
                  <p-button *ngIf="canManageStorage" icon="pi pi-calculator" label="Recalculate Charges" severity="secondary" [text]="true" (click)="recalculateYardCharges(visit)"></p-button>
                </div>

                <div class="execution-actions" *ngIf="canManageStorage && !visit.gateOutAt">
                  <p-button icon="pi pi-arrows-h" label="Record Move" severity="info" [text]="true" (click)="openYardMoveDialog(visit)"></p-button>
                  <p-button icon="pi pi-lock" label="Hold" severity="warn" [text]="true" (click)="openYardMoveDialog(visit, 'HOLD')"></p-button>
                  <p-button icon="pi pi-lock-open" label="Release" severity="success" [text]="true" (click)="openYardMoveDialog(visit, 'RELEASE_HOLD')"></p-button>
                  <p-button icon="pi pi-sign-out" label="Gate Out" severity="danger" [text]="true" (click)="openYardGateOutDialog(visit)"></p-button>
                </div>
              </article>
            </div>
          </app-page-data-panel>
        </section>
      </p-tabpanel>

      <p-tabpanel [value]="5">
        <section class="workspace-section">
          <app-page-data-panel title="Transport / Storage Handoffs" subtitle="Lifecycle orchestration bridge between movement legs, terminal yard stays, and WMS storage episodes." [resultText]="handoffs.length + ' handoffs'">
            <div class="dispatch-board case-leg-board">
              <div>
                <span>Total Handoffs</span>
                <strong>{{ handoffs.length }}</strong>
                <small>transport-storage transitions</small>
              </div>
              <div>
                <span>Blocked</span>
                <strong>{{ blockedHandoffCount() }}</strong>
                <small>requires context or override</small>
              </div>
              <div>
                <span>Active Transport</span>
                <strong>{{ activeTransportLeg() ? transportLegLabel(activeTransportLeg()?.id) : 'None' }}</strong>
                <small>{{ activeTransportLeg()?.status || 'No active movement' }}</small>
              </div>
              <div>
                <span>Active Storage</span>
                <strong>{{ activeStorageLeg() ? storageLegLabel(activeStorageLeg()?.id) : 'None' }}</strong>
                <small>{{ activeStorageLeg()?.status || 'No active dwell' }}</small>
              </div>
            </div>
            <div class="execution-actions panel-actions" *ngIf="canManageLegs || canManageStorage">
              <p-button icon="pi pi-refresh" label="Reconcile Handoffs" severity="info" [outlined]="true" (click)="reconcileHandoffs()" [loading]="isSubmitting"></p-button>
            </div>
            <p-table [value]="handoffs" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '76rem' }">
              <ng-template pTemplate="header">
                <tr>
                  <th>Type</th><th>Status</th><th>From</th><th>To</th><th>Facility</th><th>Yard Visit</th><th>Completed</th><th>Reason / Ref</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-handoff>
                <tr>
                  <td>{{ handoffTypeLabel(handoff.handoffType) }}</td>
                  <td><p-tag [value]="handoff.status || '-'" [severity]="statusSeverity(handoff.status)"></p-tag></td>
                  <td>{{ handoff.fromTransportLegId ? transportLegLabel(handoff.fromTransportLegId) : storageLegLabel(handoff.fromStorageLegId) }}</td>
                  <td>{{ handoff.toStorageLegId ? storageLegLabel(handoff.toStorageLegId) : transportLegLabel(handoff.toTransportLegId) }}</td>
                  <td>{{ facilityLabel(handoff.facilityId, handoff.locationText) }}</td>
                  <td>{{ handoffYardVisitLabel(handoff.yardVisitId) }}</td>
                  <td>{{ handoff.actualCompletedAt ? dateTimeLabel(handoff.actualCompletedAt) : 'Pending' }}</td>
                  <td>{{ handoff.blockingReason || handoff.sourceReference || handoff.remarks || '-' }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr><td colspan="8"><div class="table-empty">No handoffs have been created for this case yet.</div></td></tr>
              </ng-template>
            </p-table>
          </app-page-data-panel>
        </section>
      </p-tabpanel>

      <p-tabpanel [value]="6">
        <div class="detail-grid">
          <app-page-data-panel title="Execution Readiness" subtitle="Live blocker state for next-leg progression and closure." resultText="Live projection">
            <div class="link-grid">
              <div class="link-card">
                <strong>Container Available</strong>
                <span>{{ readiness?.containerAvailable ? 'Yes' : 'No' }}</span>
              </div>
              <div class="link-card">
                <strong>Customs Released</strong>
                <span>{{ readiness?.customsReleased ? 'Yes' : 'No' }}</span>
              </div>
              <div class="link-card">
                <strong>Line Released</strong>
                <span>{{ readiness?.lineReleased ? 'Yes' : 'No' }}</span>
              </div>
              <div class="link-card">
                <strong>Return Complete</strong>
                <span>{{ readiness?.returnComplete ? 'Yes' : 'No' }}</span>
              </div>
            </div>
          </app-page-data-panel>

          <app-page-data-panel title="Exception Signals" subtitle="Live exception queue for this lifecycle case." [resultText]="exceptions.length + ' signals'">
            <div class="exception-stack" *ngIf="exceptions.length; else noExceptions">
              <div class="exception-card" *ngFor="let exception of exceptions">
                <div class="timeline-meta">
                  <strong>{{ exception.title }}</strong>
                  <p-tag [value]="exception.severity || 'info'" [severity]="exceptionSeverity(exception.severity)"></p-tag>
                </div>
                <span>{{ exception.detail }}</span>
              </div>
            </div>
          </app-page-data-panel>
        </div>
      </p-tabpanel>

      <p-tabpanel [value]="7">
        <section class="workspace-section journey-plan-workspace">
          <app-page-data-panel
            title="Container Journey Plan"
            subtitle="Outline transport and storage steps before releasing work to transport planning or storage operations."
            [resultText]="activeJourneyPlan()?.plan?.planNumber || 'No plan'">
            <div actions class="journey-plan-actions">
              <p-button *ngIf="!activeJourneyPlan()" label="Create Blank Plan" icon="pi pi-plus" (click)="createJourneyPlan()" [loading]="isSubmitting"></p-button>
              <ng-container *ngIf="activeJourneyPlan()">
                <p-button *ngIf="journeyPlanAmendable()" label="Add Transport Step" icon="pi pi-truck" severity="secondary" [outlined]="true" (click)="openJourneyItemDialog('TRANSPORT')"></p-button>
                <p-button *ngIf="journeyPlanAmendable()" label="Add Storage Step" icon="pi pi-warehouse" severity="secondary" [outlined]="true" (click)="openJourneyItemDialog('STORAGE')"></p-button>
                <p-button label="Save as Template" icon="pi pi-copy" severity="secondary" [outlined]="true" (click)="openSaveJourneyTemplateDialog()"></p-button>
              </ng-container>
            </div>

            <div *ngIf="!activeJourneyPlan()" class="journey-empty">
              <i class="pi pi-directions"></i>
              <strong>No journey plan yet</strong>
              <span>Create a plan directly for this case. A template is optional and can be created later from the finished plan.</span>
              <div class="journey-template-start" *ngIf="journeyTemplates.length">
                <p-select
                  [options]="journeyTemplates"
                  optionLabel="template.templateName"
                  optionValue="template.id"
                  [(ngModel)]="selectedJourneyTemplateId"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Optional journey template"
                  appendTo="body">
                  <ng-template let-view pTemplate="item">
                    <div class="select-option-stack">
                      <strong>{{ view.template?.templateCode }} · {{ view.template?.templateName }}</strong>
                      <small>Version {{ view.template?.version || 1 }} · {{ view.items?.length || 0 }} steps</small>
                    </div>
                  </ng-template>
                </p-select>
                <p-button label="Start from Template" icon="pi pi-copy" [disabled]="!selectedJourneyTemplateId"
                  (click)="createJourneyPlan(selectedJourneyTemplateId)" [loading]="isSubmitting"></p-button>
              </div>
            </div>

            <ng-container *ngIf="activeJourneyPlan() as planView">
              <div class="journey-plan-summary">
                <div>
                  <span>Plan</span>
                  <strong>{{ planView.plan?.planNumber || '-' }}</strong>
                  <small>Revision {{ planView.plan?.revision || 1 }}</small>
                </div>
                <div>
                  <span>Status</span>
                  <p-tag [value]="planView.plan?.status || 'DRAFT'" [severity]="statusSeverity(planView.plan?.status)"></p-tag>
                  <small>{{ planView.plan?.sourceTemplateId ? 'Created from a template snapshot' : 'Created directly for this container case' }}</small>
                </div>
                <div>
                  <span>Planned Start</span>
                  <strong>{{ dateTimeLabel(planView.plan?.plannedStartAt) }}</strong>
                  <small>{{ journeyItems().length }} ordered steps</small>
                </div>
                <div>
                  <span>Confirmation</span>
                  <strong>{{ planView.plan?.confirmedAt ? dateTimeLabel(planView.plan?.confirmedAt) : 'Not confirmed' }}</strong>
                  <small>Steps are confirmed independently. New draft steps can be appended as plan amendments.</small>
                </div>
              </div>

              <div *ngIf="!journeyItems().length" class="journey-empty compact">
                <i class="pi pi-list"></i>
                <strong>Add the first journey step</strong>
                <span>Build the operating sequence first; no order release or storage leg is created until confirmation.</span>
              </div>

              <div class="journey-step-list" *ngIf="journeyItems().length">
                <article class="journey-step-card" *ngFor="let item of journeyItems(); let last = last"
                  [class.transport]="item.itemType === 'TRANSPORT'"
                  [class.storage]="item.itemType === 'STORAGE'">
                  <div class="journey-step-sequence">
                    <span>{{ item.sequenceNo }}</span>
                    <i [class]="item.itemType === 'TRANSPORT' ? 'pi pi-truck' : 'pi pi-warehouse'"></i>
                  </div>
                  <div class="journey-step-content">
                    <div class="journey-step-heading">
                      <div>
                        <span>{{ item.itemType === 'TRANSPORT' ? 'Transport Step' : 'Storage Step' }}</span>
                        <strong>{{ item.stepName || (item.itemType === 'TRANSPORT' ? 'Transport movement' : 'Storage dwell') }}</strong>
                      </div>
                      <div class="journey-step-state-actions">
                        <p-tag [value]="item.status || 'DRAFT'" [severity]="statusSeverity(item.status)"></p-tag>
                        <ng-container *ngIf="journeyItemEditable(item)">
                          <p-button
                            icon="pi pi-pencil"
                            severity="secondary"
                            [text]="true"
                            [rounded]="true"
                            pTooltip="Edit unconfirmed step"
                            tooltipPosition="top"
                            [attr.aria-label]="'Edit journey step ' + item.sequenceNo"
                            (click)="editJourneyItem(item)">
                          </p-button>
                          <p-button
                            icon="pi pi-trash"
                            severity="danger"
                            [text]="true"
                            [rounded]="true"
                            pTooltip="Delete unconfirmed step"
                            tooltipPosition="top"
                            [attr.aria-label]="'Delete journey step ' + item.sequenceNo"
                            (click)="openJourneyItemDeleteDialog(item)">
                          </p-button>
                          <p-button
                            label="Confirm Step"
                            icon="pi pi-check"
                            size="small"
                            (click)="confirmJourneyItem(item)"
                            [loading]="isSubmitting">
                          </p-button>
                        </ng-container>
                        <p-button *ngIf="item.status === 'AWAITING_DISPATCH' && canManageLegs && canCreateShipments"
                          label="Create Shipment" icon="pi pi-truck" size="small"
                          (click)="openDispatchDialog(item)" [loading]="isSubmitting"></p-button>
                        <p-button *ngIf="item.status === 'AWAITING_DISPATCH' && canManageLegs"
                          label="Send to Planning" icon="pi pi-sitemap" size="small" severity="secondary"
                          [outlined]="true" (click)="sendJourneyItemToPlanning(item)" [loading]="isSubmitting"></p-button>
                      </div>
                    </div>
                    <div class="journey-step-route">
                      <i class="pi pi-map-marker"></i>
                      <strong>{{ journeyStepSummary(item) }}</strong>
                    </div>
                    <div class="journey-step-details">
                      <div>
                        <span>Window</span>
                        <strong>{{ dateTimeLabel(item.plannedStartAt) }}</strong>
                        <small>to {{ dateTimeLabel(item.plannedEndAt) }}</small>
                      </div>
                      <div>
                        <span>Control</span>
                        <strong>{{ journeyStepOwnership(item) }}</strong>
                        <small *ngIf="item.itemType === 'TRANSPORT'">{{ item.transportMode || 'Mode pending' }} | {{ item.priority || 'NORMAL' }}</small>
                        <small *ngIf="item.itemType === 'STORAGE'">{{ item.storageControlMode || 'MANAGED' }} | {{ item.storageReason || 'Storage' }}</small>
                      </div>
                      <div>
                        <span>Downstream Record</span>
                        <button
                          *ngIf="item.transportOrderReleaseId"
                          type="button"
                          class="journey-downstream-link"
                          (click)="openTransportRelease(item.transportOrderReleaseId)">
                          <strong>{{ journeyReleaseReference(item) }}</strong>
                          <i class="pi pi-external-link"></i>
                        </button>
                        <button *ngIf="item.shipmentDeliveryId && !item.transportOrderReleaseId"
                          type="button" class="journey-downstream-link" (click)="openJourneyShipmentDelivery(item)">
                          <strong>Open shipment delivery</strong><i class="pi pi-external-link"></i>
                        </button>
                        <strong *ngIf="!item.transportOrderReleaseId && item.containerStorageLegId">Storage leg created</strong>
                        <strong *ngIf="item.status === 'AWAITING_DISPATCH'">Ready to group into a shipment</strong>
                        <strong *ngIf="!item.transportOrderReleaseId && !item.containerStorageLegId && item.status !== 'AWAITING_DISPATCH' && !item.shipmentDeliveryId">Not dispatched</strong>
                        <small *ngIf="item.shipmentDeliveryId">Shipment delivery linked</small>
                        <small *ngIf="item.transportOrderReleaseId && !item.shipmentDeliveryId">Awaiting shipment planning</small>
                      </div>
                    </div>
                  </div>
                  <div class="journey-connector" *ngIf="!last"><i class="pi pi-arrow-down"></i></div>
                </article>
              </div>
            </ng-container>
          </app-page-data-panel>
        </section>
      </p-tabpanel>

      <p-tabpanel [value]="8">
        <app-page-data-panel title="Linked Records" subtitle="Live typed links to shipment, clearance, warehousing, and operational records." [resultText]="links.length + ' links'">
          <p-table [value]="links" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr><th>Type</th><th>Reference</th><th>Relation</th><th>Status</th><th></th></tr>
            </ng-template>
            <ng-template pTemplate="body" let-link>
              <tr>
                <td>{{ resourceLinkLabel(link) }}</td>
                <td>{{ linkedRecordReferenceLabel(link) }}</td>
                <td>{{ relationTypeLabel(link.relationType) }}</td>
                <td><p-tag [value]="link.status || 'ACTIVE'" severity="info"></p-tag></td>
                <td><div class="flex gap-2 justify-content-end">
                  <p-button *ngIf="link.resourceType === 'PURCHASE_ORDER'" label="Receive against PO" icon="pi pi-sign-in"
                    size="small" severity="success" [text]="true" (click)="receiveAgainstPurchaseOrder(link)"></p-button>
                  <p-button *ngIf="routeForLink(link)" icon="pi pi-external-link" severity="secondary" [text]="true" (click)="navigateToLinkedResource(link)"></p-button>
                </div></td>
              </tr>
            </ng-template>
          </p-table>
        </app-page-data-panel>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <app-field-resources-panel
    *ngIf="caseItem?.id"
    targetType="CONTAINER_CASE"
    [targetId]="caseItem.id"
    [targetReference]="caseItem.caseNumber || caseItem.containerNumber"
    [logisticsProjectId]="caseItem.logisticsProjectId"
    [customerCrmClientId]="caseItem.crmClientId">
  </app-field-resources-panel>
</app-page-shell>

<ng-template #emptyTimeline>
  <div class="table-empty">No lifecycle timeline events are available for this case.</div>
</ng-template>

<ng-template #noExceptions>
  <div class="table-empty">No exception signals are active for this lifecycle case.</div>
</ng-template>

<ng-template #emptyTransportLegs>
  <div class="empty-state compact-empty">
    <i class="pi pi-truck"></i>
    <strong>No transport execution links</strong>
    <span>Plan the journey, confirm its transport steps, and reconcile shipment delivery execution here.</span>
  </div>
</ng-template>

<ng-template #emptyStorageLegs>
  <div class="empty-state compact-empty">
    <i class="pi pi-warehouse"></i>
    <strong>No yard or storage legs</strong>
    <span>Add a bonded yard, CFS, warehouse staging, or empty depot leg to control dwell and free-time risk.</span>
  </div>
</ng-template>

<p-dialog [(visible)]="journeyItemDialogVisible" [modal]="true" [style]="{width: '980px', maxWidth: '96vw'}"
  [breakpoints]="{'960px': '96vw'}" styleClass="case-leg-dialog master-case-dialog journey-step-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-rich-header">
      <div class="dialog-title-icon"><i [class]="journeyItemForm.get('itemType')?.value === 'TRANSPORT' ? 'pi pi-truck' : 'pi pi-warehouse'"></i></div>
      <div>
        <strong>{{ editingJourneyItem ? 'Edit' : 'Add' }} {{ journeyItemForm.get('itemType')?.value === 'TRANSPORT' ? 'Transport' : 'Storage' }} Step</strong>
        <span>{{ editingJourneyItem ? 'Update this unconfirmed step without releasing downstream work.' : 'Plan the journey first. Operational records are created only after confirmation.' }}</span>
      </div>
    </div>
  </ng-template>

  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i [class]="journeyItemForm.get('itemType')?.value === 'TRANSPORT' ? 'pi pi-truck' : 'pi pi-warehouse'"></i></div>
      <div>
        <small>Journey planning</small>
        <h3>{{ editingJourneyItem ? 'Revise planned step' : 'Add journey step' }}</h3>
        <p>Define the intended movement or dwell before any downstream order release or storage operation is created.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Plan</span><strong>{{ activeJourneyPlan()?.plan?.planNumber || 'Current journey' }}</strong></div>
        <div><span>Step control</span><strong>Draft until confirmed</strong></div>
      </div>
    </aside>
  <form [formGroup]="journeyItemForm" class="dialog-form release-dialog-form">
    <div class="dialog-guidance">
      <i class="pi pi-info-circle"></i>
      <span>Templates are not required. This step belongs directly to the current container journey plan.</span>
    </div>

    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-list"></i> Step Definition</div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftalabel>
            <p-select inputId="journeyItemType" formControlName="itemType"
              [options]="[{label:'Transport', value:'TRANSPORT'}, {label:'Storage', value:'STORAGE'}]"
              optionLabel="label" optionValue="value" appendTo="body" (onChange)="onJourneyItemTypeChange()"></p-select>
            <label for="journeyItemType">Step Type *</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <input pInputText id="journeyStepName" formControlName="stepName">
            <label for="journeyStepName">Step Name</label>
          </p-iftalabel>
        </div>
      </div>
    </div>

    <div class="dialog-section" *ngIf="journeyItemForm.get('itemType')?.value === 'TRANSPORT'">
      <div class="dialog-section-title"><i class="pi pi-map-marker"></i> Transport Demand</div>
      <div class="dialog-guidance" *ngIf="journeyTransportPredecessor() as predecessor">
        <i class="pi pi-link"></i>
        <span>{{ predecessor.itemType === 'STORAGE' ? 'Dispatches from' : 'Continues from' }} Step {{ predecessor.sequenceNo }} at {{ journeyStepDestinationLabel(predecessor) }}. Planned start inherits {{ dateTimeLabel(predecessor.plannedEndAt) }}.</span>
      </div>
      <div class="dialog-form-grid">
        <ng-container *ngIf="journeyTransportPredecessor() as predecessor">
          <div class="field">
            <p-iftalabel>
              <input pInputText id="journeyTransportPredecessor" [value]="journeyStepLabel(predecessor)" readonly>
              <label for="journeyTransportPredecessor">Previous Journey Step</label>
            </p-iftalabel>
          </div>
          <div class="field">
            <p-iftalabel>
              <p-select inputId="journeyInheritedOrigin" formControlName="originLocationId" appLazyLocationPicker
                optionLabel="name" optionValue="id" appendTo="body"></p-select>
              <label for="journeyInheritedOrigin">Inherited Transport Origin</label>
            </p-iftalabel>
          </div>
        </ng-container>
        <div class="field">
          <p-iftalabel>
            <p-select inputId="journeyMode" formControlName="transportMode" [options]="transportModeOptions"
              optionLabel="label" optionValue="value" appendTo="body"></p-select>
            <label for="journeyMode">Mode *</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <p-select inputId="journeyPriority" formControlName="priority" [options]="releasePriorityOptions"
              optionLabel="label" optionValue="value" appendTo="body"></p-select>
            <label for="journeyPriority">Priority</label>
          </p-iftalabel>
        </div>
        <div class="field" *ngIf="!journeyTransportPredecessor()">
          <p-iftalabel>
            <p-select inputId="journeyOrigin" formControlName="originLocationId" appLazyLocationPicker
              optionLabel="name" optionValue="id" [filter]="true" appendTo="body"></p-select>
            <label for="journeyOrigin">Origin Location *</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <p-select inputId="journeyDestination" formControlName="destinationLocationId" appLazyLocationPicker
              optionLabel="name" optionValue="id" [filter]="true" appendTo="body"></p-select>
            <label for="journeyDestination">Destination Location *</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <p-select inputId="journeyVehicleType" formControlName="vehicleTypeId" [options]="vehicleTypes"
              optionLabel="name" optionValue="id" [filter]="true" appendTo="body" [showClear]="true"></p-select>
            <label for="journeyVehicleType">Vehicle Type Hint</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <p-select inputId="journeyRouteTemplate" formControlName="routeTemplateId" [options]="routeTemplates"
              optionLabel="templateName" optionValue="id" [filter]="true" appendTo="body" [showClear]="true"></p-select>
            <label for="journeyRouteTemplate">Route Template</label>
          </p-iftalabel>
        </div>
        <ng-container *ngIf="journeyStorageItems().length > 0">
          <div class="field" *ngIf="!journeyTransportPredecessor() || journeyTransportPredecessor()?.itemType === 'STORAGE'">
            <p-iftalabel>
              <p-select inputId="journeySourceStorage" formControlName="sourceStoragePlanItemId"
                [options]="journeyStorageItems()" optionLabel="stepName" optionValue="id" appendTo="body" [showClear]="true"></p-select>
              <label for="journeySourceStorage">{{ journeyTransportPredecessor()?.itemType === 'STORAGE' ? 'Inherited Source Storage Step' : 'Source Storage Step' }}</label>
            </p-iftalabel>
          </div>
          <div class="field">
            <p-iftalabel>
              <p-select inputId="journeyDestinationStorage" formControlName="destinationStoragePlanItemId"
                [options]="journeyStorageItems()" optionLabel="stepName" optionValue="id" appendTo="body" [showClear]="true"></p-select>
              <label for="journeyDestinationStorage">Destination Storage Step</label>
            </p-iftalabel>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="dialog-section" *ngIf="journeyItemForm.get('itemType')?.value === 'STORAGE'">
      <div class="dialog-section-title"><i class="pi pi-building"></i> Storage Plan</div>
      <div class="dialog-guidance" *ngIf="journeyStoragePredecessor() as predecessor">
        <i class="pi pi-link"></i>
        <span>Linked from Step {{ predecessor.sequenceNo }} at {{ journeyStepDestinationLabel(predecessor) }}. Planned start inherits {{ dateTimeLabel(predecessor.plannedEndAt) }}.</span>
      </div>
      <ng-container *ngIf="journeyStoragePredecessor() as predecessor">
        <div class="dialog-warning" *ngIf="journeyStorageFacilityOptions().length === 0">
          <i class="pi pi-exclamation-triangle"></i>
          <span>No active terminal facility is mapped to {{ journeyStepDestinationLabel(predecessor) }}. Update Terminal Facilities setup before adding this storage step.</span>
        </div>
      </ng-container>
      <div class="dialog-form-grid">
        <ng-container *ngIf="journeyStoragePredecessor() as predecessor">
          <div class="field">
            <p-iftalabel>
              <input pInputText id="journeyPredecessor" [value]="journeyStepLabel(predecessor)" readonly>
              <label for="journeyPredecessor">Previous Journey Step</label>
            </p-iftalabel>
          </div>
          <div class="field">
            <p-iftalabel>
              <p-select inputId="journeyStorageLocation" formControlName="locationId" appLazyLocationPicker
                optionLabel="name" optionValue="id" appendTo="body"></p-select>
              <label for="journeyStorageLocation">Inherited Storage Location</label>
            </p-iftalabel>
          </div>
        </ng-container>
        <div class="field span-2">
          <p-iftalabel>
            <p-select inputId="journeyFacility" formControlName="facilityId" [options]="journeyStorageFacilityOptions()"
              optionLabel="facilityName" optionValue="id" [filter]="true" appendTo="body"
              (onChange)="onJourneyFacilityChange($event.value)"></p-select>
            <label for="journeyFacility">Terminal / Facility *</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <p-select inputId="journeyStorageMode" formControlName="storageControlMode"
              [options]="[{label:'Managed Storage', value:'MANAGED'}, {label:'Third-party Reference Only', value:'REFERENCE_ONLY'}]"
              optionLabel="label" optionValue="value" appendTo="body"></p-select>
            <label for="journeyStorageMode">Control Mode</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <input pInputText id="journeyStorageReason" formControlName="storageReason">
            <label for="journeyStorageReason">Storage Reason</label>
          </p-iftalabel>
        </div>
      </div>
    </div>

    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-calendar"></i> Planned Window</div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftalabel>
            <p-datepicker inputId="journeyStart" formControlName="plannedStartAt" [showTime]="true" appendTo="body"
              (onSelect)="onJourneyPlannedStartChange()"></p-datepicker>
            <label for="journeyStart">Planned Start *</label>
          </p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel>
            <p-datepicker inputId="journeyEnd" formControlName="plannedEndAt" [showTime]="true" appendTo="body"
              [minDate]="journeyEndMinimum"></p-datepicker>
            <label for="journeyEnd">Planned End *</label>
          </p-iftalabel>
        </div>
        <div class="dialog-warning span-2" *ngIf="journeyItemForm.hasError('plannedEndBeforeStart')">
          <i class="pi pi-exclamation-triangle"></i>
          <span>Planned end must be the same as or later than planned start.</span>
        </div>
        <div class="field span-2">
          <p-iftalabel>
            <textarea pTextarea id="journeyRemarks" formControlName="remarks" rows="3"></textarea>
            <label for="journeyRemarks">Planning Notes</label>
          </p-iftalabel>
        </div>
      </div>
    </div>
  </form>
  </section>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="closeJourneyItemDialog()"></p-button>
    <p-button [label]="editingJourneyItem ? 'Save Changes' : 'Add to Journey Plan'" icon="pi pi-check"
      (click)="saveJourneyItem()" [loading]="isSubmitting" [disabled]="journeyItemForm.invalid"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="dispatchDialogVisible" [modal]="true"
  [style]="{width: '1100px', maxWidth: '96vw'}" [breakpoints]="{'640px': '96vw'}"
  styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-rich-header">
      <div class="dialog-title-icon"><i class="pi pi-truck"></i></div>
      <div><strong>Create Container Shipment</strong><span>Group compatible cases on one planned delivery.</span></div>
    </div>
  </ng-template>
  <section class="release-dialog-body dispatch-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-box"></i></div>
      <div><small>Shipment planning</small><h3>{{ selectedDispatchCandidates.length }} container(s) selected</h3>
        <p>The cases share a customer, project, route, and overlapping time windows. Check the vehicle's container and weight limits before assignment.</p></div>
    </aside>
    <div class="dispatch-dialog-card">
      <strong>Commercial details</strong>
      <div class="dispatch-commercial-fields">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-receipt"></i></p-inputGroupAddon>
          <p-iftalabel><p-select inputId="dispatchTerm" [options]="dispatchPaymentTerms" [(ngModel)]="dispatchPaymentTermId"
            optionLabel="name" optionValue="paymentTermID" [filter]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="dispatchTerm">Commercial payment term *</label></p-iftalabel>
        </p-inputGroup>
        <ng-container *ngIf="dispatchCanViewPricing">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
            <p-iftalabel><p-select inputId="dispatchCurrency" [options]="dispatchCurrencies" [(ngModel)]="dispatchCurrency"
              (ngModelChange)="dispatchPricingContextChanged()" appendTo="body" styleClass="w-full"></p-select>
              <label for="dispatchCurrency">Currency</label></p-iftalabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
            <p-iftalabel><p-select inputId="dispatchSource" [options]="dispatchRateSources" [(ngModel)]="dispatchRateSource"
              optionLabel="label" optionValue="value" (ngModelChange)="dispatchSourceChanged()" appendTo="body" styleClass="w-full"></p-select>
              <label for="dispatchSource">Customer selling source</label></p-iftalabel>
          </p-inputGroup>
          <ng-container *ngIf="dispatchRateSource === 'RATE_CARD'">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
              <p-iftalabel><p-select inputId="dispatchContract" [options]="dispatchContracts" [(ngModel)]="dispatchContract"
                optionLabel="contractNumber" [filter]="true" [showClear]="true" [loading]="dispatchContractsLoading"
                [virtualScroll]="true" [virtualScrollItemSize]="38" (onLazyLoad)="loadDispatchContracts($event)"
                (ngModelChange)="dispatchContractChanged()" appendTo="body" styleClass="w-full"></p-select>
                <label for="dispatchContract">Customer contract</label></p-iftalabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-clone"></i></p-inputGroupAddon>
              <p-iftalabel><p-select inputId="dispatchRevision" [options]="dispatchContract?.revisions || []" [(ngModel)]="dispatchRevisionId"
                optionLabel="revisionNumber" optionValue="revisionID" [disabled]="!dispatchContract" (ngModelChange)="dispatchRevisionChanged()" appendTo="body" styleClass="w-full"></p-select>
                <label for="dispatchRevision">Contract revision</label></p-iftalabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
              <p-iftalabel><p-select inputId="dispatchRateCard" [options]="dispatchRateCards" [(ngModel)]="dispatchRateCard"
                optionLabel="rateId" [showClear]="true" (ngModelChange)="previewDispatchRate()" appendTo="body" styleClass="w-full">
                <ng-template let-card pTemplate="item">{{ card.sourceCity || 'Source' }} → {{ card.destinationCity || 'Destination' }} ({{ card.amount | number:'1.2-2' }} {{ dispatchCurrency }})</ng-template>
                <ng-template let-card pTemplate="selectedItem">{{ card.sourceCity || 'Source' }} → {{ card.destinationCity || 'Destination' }} ({{ card.amount | number:'1.2-2' }} {{ dispatchCurrency }})</ng-template>
              </p-select>
                <label for="dispatchRateCard">Customer rate card</label></p-iftalabel>
            </p-inputGroup>
          </ng-container>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-arrow-up"></i></p-inputGroupAddon>
            <p-iftalabel><p-inputNumber inputId="dispatchPrice" [(ngModel)]="dispatchSellingPrice" [min]="0"
              [minFractionDigits]="2" [maxFractionDigits]="2" [readonly]="dispatchRateSource === 'RATE_CARD'" styleClass="w-full"></p-inputNumber>
              <label for="dispatchPrice">Selling price</label></p-iftalabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon>
            <p-iftalabel><input id="dispatchReason" pInputText [(ngModel)]="dispatchOverrideReason" />
              <label for="dispatchReason">Manual override reason</label></p-iftalabel>
          </p-inputGroup>
        </ng-container>
      </div>
      <small *ngIf="!dispatchPaymentTerms.length" class="p-error">No active payment terms are available for this company.</small>
      <small *ngFor="let warning of dispatchPricingWarnings" class="dispatch-message">{{ warning }}</small>
      <small *ngIf="dispatchError" class="p-error dispatch-message" role="alert">{{ dispatchError }}</small>
      <strong>Available containers</strong>
      <p-table [value]="dispatchCandidates" dataKey="journeyItemId" [(selection)]="selectedDispatchCandidates"
        (selectionChange)="dispatchPricingContextChanged()" [scrollable]="true" scrollHeight="360px" styleClass="p-datatable-sm">
        <ng-template pTemplate="header"><tr><th style="width: 3rem"></th><th>Case</th><th>Container</th><th>Step</th><th>Planned window</th></tr></ng-template>
        <ng-template pTemplate="body" let-candidate>
          <tr><td><p-tableCheckbox [value]="candidate" [attr.aria-label]="'Select container ' + (candidate.containerNumber || candidate.caseNumber)"></p-tableCheckbox></td>
            <td>{{ candidate.caseNumber }}</td><td>{{ candidate.containerNumber || '-' }}</td>
            <td>{{ candidate.stepName || 'Road movement' }}</td>
            <td>{{ candidate.plannedStartAt | date:'short' }} – {{ candidate.plannedEndAt | date:'short' }}</td></tr>
        </ng-template>
      </p-table>
      <small *ngIf="!dispatchCandidates.length">No compatible confirmed steps are available.</small>
      <small *ngIf="selectedDispatchCandidates.length && !dispatchSelectionCompatible()">Selected time windows must overlap.</small>
    </div>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="dispatchDialogVisible = false"></p-button>
    <p-button label="Create Shipment" icon="pi pi-truck" [disabled]="!dispatchSelectionCompatible() || !dispatchPaymentTermId || dispatchRateLoading"
      [loading]="isSubmitting" (click)="createGroupedShipment()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="journeyItemDeleteDialogVisible" [modal]="true"
  [style]="{width: '760px', maxWidth: '94vw'}" styleClass="case-leg-dialog master-case-dialog journey-delete-dialog"
  [draggable]="false" [resizable]="false" (onHide)="closeJourneyItemDeleteDialog()">
  <ng-template pTemplate="header">
    <div class="dialog-rich-header">
      <div class="dialog-title-icon danger"><i class="pi pi-trash"></i></div>
      <div>
        <strong>Delete Journey Step</strong>
        <span>Remove this unconfirmed step from the planned sequence.</span>
      </div>
    </div>
  </ng-template>

  <section class="release-dialog-body delete-dialog-body" *ngIf="journeyItemPendingDelete as item">
    <aside class="release-dialog-summary danger-summary">
      <div class="summary-icon danger"><i class="pi pi-trash"></i></div>
      <div>
        <small>Journey control</small>
        <h3>Remove draft step</h3>
        <p>Only unconfirmed planning records can be deleted. No released transport or storage execution is changed.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Sequence</span><strong>Step {{ item.sequenceNo }}</strong></div>
      </div>
    </aside>
  <div class="journey-delete-content">
    <div class="journey-delete-step">
      <span>Step {{ item.sequenceNo }} · {{ item.itemType === 'TRANSPORT' ? 'Transport' : 'Storage' }}</span>
      <strong>{{ item.stepName || (item.itemType === 'TRANSPORT' ? 'Transport movement' : 'Storage dwell') }}</strong>
      <small>{{ journeyStepSummary(item) }}</small>
    </div>
    <div class="dialog-guidance danger">
      <i class="pi pi-exclamation-triangle"></i>
      <span>The remaining steps will be resequenced. This action is unavailable once the step is confirmed.</span>
    </div>
  </div>
  </section>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
      (click)="closeJourneyItemDeleteDialog()"></p-button>
    <p-button label="Delete Step" icon="pi pi-trash" severity="danger"
      (click)="deleteJourneyItem()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="journeyTemplateDialogVisible" [modal]="true" [style]="{width: '760px', maxWidth: '96vw'}"
  styleClass="case-leg-dialog master-case-dialog journey-template-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-rich-header">
      <div class="dialog-title-icon"><i class="pi pi-copy"></i></div>
      <div>
        <strong>Save Journey as Template</strong>
        <span>Create a reusable definition without carrying case or execution records into future journeys.</span>
      </div>
    </div>
  </ng-template>
  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-copy"></i></div>
      <div>
        <small>Reusable journey</small>
        <h3>{{ journeyTemplateForm.get('templateName')?.value || 'New journey template' }}</h3>
        <p>Capture the reusable sequence while excluding case-specific shipment, delivery, yard, and actual execution records.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Source plan</span><strong>{{ activeJourneyPlan()?.plan?.planNumber || '-' }}</strong></div>
        <div><span>Steps</span><strong>{{ journeyItems().length }}</strong></div>
        <div><span>Current case</span><strong>Unchanged</strong></div>
      </div>
    </aside>
  <form [formGroup]="journeyTemplateForm" class="dialog-form release-dialog-form">
    <div class="dialog-guidance">
      <i class="pi pi-shield"></i>
      <span>The current plan remains unchanged. Release, shipment, delivery, leg, yard, slot, and actual-operation references are excluded.</span>
    </div>
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-file"></i> Template Identity</div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftalabel><input pInputText id="journeyTemplateCode" formControlName="templateCode"><label for="journeyTemplateCode">Template Code *</label></p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel><input pInputText id="journeyTemplateName" formControlName="templateName"><label for="journeyTemplateName">Template Name *</label></p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel><input pInputText id="journeyType" formControlName="journeyType"><label for="journeyType">Journey Type</label></p-iftalabel>
        </div>
        <div class="field">
          <p-iftalabel><input pInputText id="journeyEquipment" formControlName="applicableEquipmentTypes"><label for="journeyEquipment">Applicable Equipment</label></p-iftalabel>
        </div>
        <div class="field span-2">
          <p-iftalabel><textarea pTextarea id="journeyTemplateDescription" formControlName="description" rows="3"></textarea><label for="journeyTemplateDescription">Description</label></p-iftalabel>
        </div>
      </div>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="journeyTemplateDialogVisible = false"></p-button>
    <p-button label="Save Template" icon="pi pi-check" (click)="saveJourneyAsTemplate()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="handoffDialogVisible" [modal]="true" [style]="{width: '980px', maxWidth: '96vw'}" [breakpoints]="{'960px': '96vw'}" styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-arrows-h"></i></span>
      <span>
        <strong>{{ handoffActionTitle() }}</strong>
        <small>{{ handoffActionSubtitle() }}</small>
      </span>
    </div>
  </ng-template>
  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-arrows-h"></i></div>
      <div>
        <small>Lifecycle handoff</small>
        <h3>{{ handoffActionTitle() }}</h3>
        <p>Connect transport execution and storage dwell while operational ownership remains with the transport, WMS, or yard module.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Active transport</span><strong>{{ activeTransportLeg()?.sequenceNo ? 'Leg ' + activeTransportLeg()?.sequenceNo : 'None' }}</strong></div>
        <div><span>Active storage</span><strong>{{ activeStorageLeg()?.sequenceNo ? 'Leg ' + activeStorageLeg()?.sequenceNo : 'None' }}</strong></div>
      </div>
    </aside>
  <form [formGroup]="handoffForm" class="dialog-form release-dialog-form">
    <div class="dialog-guidance">
      <i class="pi pi-info-circle"></i>
      <span>{{ handoffGuidance() }}</span>
    </div>

    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-link"></i><span>Leg Links</span></div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="handoffSourceStorage" [options]="storageLegs" optionLabel="sequenceNo" optionValue="id" formControlName="sourceStorageLegId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffSourceStorage">Source Storage</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="handoffTargetStorage" [options]="storageLegs" optionLabel="sequenceNo" optionValue="id" formControlName="targetStorageLegId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffTargetStorage">Target Storage</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="handoffSourceTransport" [options]="transportLegs" optionLabel="sequenceNo" optionValue="id" formControlName="sourceTransportLegId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffSourceTransport">Source Transport</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="handoffTargetTransport" [options]="transportLegs" optionLabel="sequenceNo" optionValue="id" formControlName="targetTransportLegId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffTargetTransport">Target Transport</label>
          </p-iftaLabel>
        </div>
      </div>
    </div>

    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-map-marker"></i><span>Facility Context</span></div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="handoffFacilityType" [options]="storageFacilityOptions" optionLabel="label" optionValue="value" formControlName="facilityType" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffFacilityType">Facility Type</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="handoffFacility" [options]="facilities" optionLabel="facilityName" optionValue="id" formControlName="facilityId" [filter]="true" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffFacility">Facility</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="handoffYardVisit" [options]="yardVisits" optionLabel="id" optionValue="id" formControlName="yardVisitId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffYardVisit">Yard Visit</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <input id="handoffLocation" pInputText formControlName="locationText">
            <label for="handoffLocation">Location Text</label>
          </p-iftaLabel>
        </div>
      </div>
    </div>

    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-calendar-clock"></i><span>Action Details</span></div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftaLabel>
            <p-datePicker inputId="handoffEventTime" formControlName="eventTime" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
            <label for="handoffEventTime">Event Time</label>
          </p-iftaLabel>
        </div>
        <div class="field" *ngIf="showAutoCreateStorage()">
          <p-iftaLabel>
            <p-select inputId="handoffAutoCreate" [options]="[{label:'No', value:false}, {label:'Yes', value:true}]" optionLabel="label" optionValue="value" formControlName="autoCreateStorageLeg" appendTo="body" styleClass="w-full"></p-select>
            <label for="handoffAutoCreate">Auto Create Storage</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <input id="handoffOverride" pInputText formControlName="overrideReason">
            <label for="handoffOverride">Override Reason</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <input id="handoffRemarks" pInputText formControlName="remarks">
            <label for="handoffRemarks">Remarks</label>
          </p-iftaLabel>
        </div>
      </div>
    </div>

    <div class="dialog-guidance warning" *ngIf="requiresOverrideReason()">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Active storage is present. Complete the storage-to-transport context or record an override reason before dispatch.</span>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="handoffDialogVisible = false"></p-button>
    <p-button [label]="handoffSubmitLabel()" icon="pi pi-check" (click)="saveHandoffAction()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="yardGateInDialogVisible" [modal]="true" [style]="{width: '980px', maxWidth: '96vw'}" [breakpoints]="{'960px': '96vw'}" styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-sign-in"></i></span>
      <span><strong>Terminal Gate In</strong><small>Create a yard visit and open the linked terminal storage leg.</small></span>
    </div>
  </ng-template>
  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-sign-in"></i></div>
      <div>
        <small>Terminal reception</small>
        <h3>Open yard stay</h3>
        <p>Create the terminal visit, receive the inbound handoff, and establish the first controlled yard location.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Seal</span><strong>{{ caseItem?.sealNumber || 'Not captured' }}</strong></div>
        <div><span>Storage result</span><strong>Active terminal leg</strong></div>
      </div>
    </aside>
  <form [formGroup]="yardGateInForm" class="dialog-form release-dialog-form">
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-warehouse"></i><span>Yard Location</span></div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInFacility" [options]="managedYardFacilities()" optionLabel="facilityName" optionValue="id" formControlName="facilityId" [filter]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInFacility">Facility *</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInArea" [options]="yardAreas" optionLabel="areaName" optionValue="id" formControlName="initialAreaId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInArea">Initial Area</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInSlot" [options]="yardSlots" optionLabel="slotCode" optionValue="id" formControlName="initialSlotId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInSlot">Initial Slot</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInTransport" [options]="transportLegs" optionLabel="sequenceNo" optionValue="id" formControlName="inboundTransportLegId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInTransport">Inbound Transport</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInAppointment" [options]="yardAppointments" optionLabel="referenceNumber" optionValue="id" formControlName="appointmentId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInAppointment">Truck Appointment</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInFullEmpty" [options]="fullEmptyOptions" optionLabel="label" optionValue="value" formControlName="emptyFullStatus" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInFullEmpty">Full / Empty</label>
          </p-iftaLabel>
        </div>
      </div>
    </div>
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-clock"></i><span>Gate Details</span></div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftaLabel>
            <p-datePicker inputId="gateInAt" formControlName="gateInAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
            <label for="gateInAt">Gate In At *</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-datePicker inputId="gateInFreeStart" formControlName="freeTimeStartAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
            <label for="gateInFreeStart">Free Time Start</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-datePicker inputId="gateInFreeEnd" formControlName="freeTimeEndAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
            <label for="gateInFreeEnd">Free Time End</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel><input id="gateInTruck" pInputText formControlName="truckPlateNumber"><label for="gateInTruck">Truck Plate</label></p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel><input id="gateInChassis" pInputText formControlName="chassisNumber"><label for="gateInChassis">Chassis</label></p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel><input id="gateInRemarks" pInputText formControlName="remarks"><label for="gateInRemarks">Remarks</label></p-iftaLabel>
        </div>
      </div>
    </div>
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-verified"></i><span>EIR Capture</span></div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInSealVerified" [options]="yesNoOptions" optionLabel="label" optionValue="value" formControlName="sealVerified" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInSealVerified">Seal Verified</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInCondition" [options]="conditionOptions" optionLabel="label" optionValue="value" formControlName="conditionStatus" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInCondition">Condition</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="gateInDamageObserved" [options]="yesNoOptions" optionLabel="label" optionValue="value" formControlName="damageObserved" appendTo="body" styleClass="w-full"></p-select>
            <label for="gateInDamageObserved">Damage Observed</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel><input id="gateInSealReason" pInputText formControlName="sealMismatchReason"><label for="gateInSealReason">Seal Mismatch Reason</label></p-iftaLabel>
        </div>
        <div class="field span-2">
          <p-iftaLabel><input id="gateInDamageNotes" pInputText formControlName="damageNotes"><label for="gateInDamageNotes">Damage Notes</label></p-iftaLabel>
        </div>
      </div>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="yardGateInDialogVisible = false"></p-button>
    <p-button label="Gate In" icon="pi pi-check" (click)="saveYardGateIn()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="yardGateOutDialogVisible" [modal]="true" [style]="{width: '920px', maxWidth: '96vw'}" styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-sign-out"></i></span>
      <span><strong>Terminal Gate Out</strong><small>Close the yard visit and complete the storage-to-transport handoff if supplied.</small></span>
    </div>
  </ng-template>
  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-sign-out"></i></div>
      <div>
        <small>Terminal dispatch</small>
        <h3>Close yard stay</h3>
        <p>Release the current slot, close the terminal storage episode, and link outbound transport when available.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Current yard</span><strong>{{ activeYardVisitLabel() }}</strong></div>
        <div><span>Storage result</span><strong>Completed</strong></div>
      </div>
    </aside>
  <form [formGroup]="yardGateOutForm" class="dialog-form release-dialog-form">
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-sign-out"></i><span>Gate-out control</span></div>
    <div class="dialog-form-grid">
      <div class="field">
        <p-iftaLabel><p-datePicker inputId="gateOutAt" formControlName="gateOutAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker><label for="gateOutAt">Gate Out At *</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-select inputId="gateOutTransport" [options]="transportLegs" optionLabel="sequenceNo" optionValue="id" formControlName="outboundTransportLegId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select><label for="gateOutTransport">Outbound Transport</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-select inputId="gateOutEmpty" [options]="[{label:'No', value:false}, {label:'Yes', value:true}]" optionLabel="label" optionValue="value" formControlName="emptyReturn" appendTo="body" styleClass="w-full"></p-select><label for="gateOutEmpty">Empty Return</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><input id="gateOutRef" pInputText formControlName="referenceNumber"><label for="gateOutRef">Reference</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-select inputId="gateOutSealVerified" [options]="yesNoOptions" optionLabel="label" optionValue="value" formControlName="sealVerified" appendTo="body" styleClass="w-full"></p-select><label for="gateOutSealVerified">Seal Verified</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-select inputId="gateOutCondition" [options]="conditionOptions" optionLabel="label" optionValue="value" formControlName="conditionStatus" appendTo="body" styleClass="w-full"></p-select><label for="gateOutCondition">Condition</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-select inputId="gateOutDamageObserved" [options]="yesNoOptions" optionLabel="label" optionValue="value" formControlName="damageObserved" appendTo="body" styleClass="w-full"></p-select><label for="gateOutDamageObserved">Damage Observed</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><input id="gateOutSealReason" pInputText formControlName="sealMismatchReason"><label for="gateOutSealReason">Seal Mismatch Reason</label></p-iftaLabel>
      </div>
      <div class="field span-2">
        <p-iftaLabel><input id="gateOutDamageNotes" pInputText formControlName="damageNotes"><label for="gateOutDamageNotes">Damage Notes</label></p-iftaLabel>
      </div>
      <div class="field span-2">
        <p-iftaLabel><input id="gateOutRemarks" pInputText formControlName="remarks"><label for="gateOutRemarks">Remarks</label></p-iftaLabel>
      </div>
    </div>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="yardGateOutDialogVisible = false"></p-button>
    <p-button label="Gate Out" icon="pi pi-check" (click)="saveYardGateOut()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="yardMoveDialogVisible" [modal]="true" [style]="{width: '920px', maxWidth: '96vw'}" styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-arrows-h"></i></span>
      <span><strong>Record Yard Move</strong><small>Append a terminal yard move and update the linked storage leg location.</small></span>
    </div>
  </ng-template>
  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-arrows-h"></i></div>
      <div>
        <small>Yard movement</small>
        <h3>Record location change</h3>
        <p>Append an immutable yard event and synchronize the current location on the linked storage leg.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Yard visit</span><strong>{{ activeYardVisitLabel() }}</strong></div>
        <div><span>Ledger</span><strong>Append-only move</strong></div>
      </div>
    </aside>
  <form [formGroup]="yardMoveForm" class="dialog-form release-dialog-form">
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-map"></i><span>Movement details</span></div>
    <div class="dialog-form-grid">
      <div class="field">
        <p-iftaLabel><p-select inputId="yardMoveType" [options]="[
          {label:'Yard Move', value:'YARD_MOVE'},
          {label:'Slot Assign', value:'SLOT_ASSIGN'},
          {label:'Inspection In', value:'INSPECTION_IN'},
          {label:'Inspection Out', value:'INSPECTION_OUT'},
          {label:'Hold', value:'HOLD'},
          {label:'Release Hold', value:'RELEASE_HOLD'},
          {label:'Dock Move', value:'DOCK_MOVE'}
        ]" optionLabel="label" optionValue="value" formControlName="moveType" appendTo="body" styleClass="w-full"></p-select><label for="yardMoveType">Move Type *</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-select inputId="yardMoveArea" [options]="yardAreas" optionLabel="areaName" optionValue="id" formControlName="toAreaId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select><label for="yardMoveArea">To Area</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-select inputId="yardMoveSlot" [options]="yardSlots" optionLabel="slotCode" optionValue="id" formControlName="toSlotId" [showClear]="true" appendTo="body" styleClass="w-full"></p-select><label for="yardMoveSlot">To Slot</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><p-datePicker inputId="yardMoveAt" formControlName="eventTime" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker><label for="yardMoveAt">Event Time *</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><input id="yardMoveRef" pInputText formControlName="referenceNumber"><label for="yardMoveRef">Reference</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><input id="yardMoveRemarks" pInputText formControlName="remarks"><label for="yardMoveRemarks">Remarks</label></p-iftaLabel>
      </div>
    </div>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="yardMoveDialogVisible = false"></p-button>
    <p-button label="Record Move" icon="pi pi-check" (click)="saveYardMove()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="storageSlotDialogVisible" [modal]="true" [style]="{width: '900px', maxWidth: '96vw'}" styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-table"></i></span>
      <span><strong>Assign Yard Slot</strong><small>Update the storage leg's current terminal area and bay/slot context.</small></span>
    </div>
  </ng-template>
  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-table"></i></div>
      <div>
        <small>Storage placement</small>
        <h3>Assign current slot</h3>
        <p>Select the operational yard area and slot while retaining the same continuous storage episode.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Facility</span><strong>{{ selectedStorageLeg?.facilityName || '-' }}</strong></div>
        <div><span>Storage state</span><strong>{{ selectedStorageLeg?.status || '-' }}</strong></div>
      </div>
    </aside>
  <form [formGroup]="storageSlotForm" class="dialog-form release-dialog-form">
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-map"></i><span>Yard Placement</span></div>
      <div class="dialog-form-grid">
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="actionStorageArea" [options]="storageActionYardAreaOptions()" optionLabel="areaName" optionValue="id" formControlName="yardAreaId" [filter]="true" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full" (onChange)="onStorageActionAreaChange($event.value)"></p-select>
            <label for="actionStorageArea">Yard Area</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <p-select inputId="actionStorageSlot" [options]="storageActionYardSlotOptions()" optionLabel="slotCode" optionValue="id" formControlName="yardSlotId" [filter]="true" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full" (onChange)="onStorageActionSlotChange($event.value)"></p-select>
            <label for="actionStorageSlot">Yard Slot</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <input id="actionStorageSlotCode" pInputText formControlName="slotCode">
            <label for="actionStorageSlotCode">Manual Slot Code</label>
          </p-iftaLabel>
        </div>
        <div class="field">
          <p-iftaLabel>
            <input id="actionStorageSlotNotes" pInputText formControlName="notes">
            <label for="actionStorageSlotNotes">Notes</label>
          </p-iftaLabel>
        </div>
      </div>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="storageSlotDialogVisible = false"></p-button>
    <p-button label="Assign Slot" icon="pi pi-check" (click)="saveStorageSlotAssignment()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="storageHoldDialogVisible" [modal]="true" [style]="{width: '820px', maxWidth: '96vw'}" styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-lock"></i></span>
      <span><strong>Apply Storage Hold</strong><small>Put the storage leg into exception state with a recorded hold reason.</small></span>
    </div>
  </ng-template>
  <section class="release-dialog-body compact-dialog-body">
    <aside class="release-dialog-summary warning-summary">
      <div class="summary-icon warning"><i class="pi pi-lock"></i></div>
      <div>
        <small>Storage exception</small>
        <h3>Apply operational hold</h3>
        <p>Pause normal storage progression and record the reason on the container lifecycle timeline.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Facility</span><strong>{{ selectedStorageLeg?.facilityName || '-' }}</strong></div>
      </div>
    </aside>
  <form [formGroup]="storageHoldForm" class="dialog-form release-dialog-form">
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-lock"></i><span>Hold details</span></div>
    <div class="dialog-form-grid single-dialog-grid">
      <div class="field">
        <p-iftaLabel><p-datePicker inputId="storageHoldAt" formControlName="eventTime" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker><label for="storageHoldAt">Event Time</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><input id="storageHoldNotes" pInputText formControlName="notes"><label for="storageHoldNotes">Hold Reason</label></p-iftaLabel>
      </div>
    </div>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="storageHoldDialogVisible = false"></p-button>
    <p-button label="Apply Hold" icon="pi pi-check" severity="warn" (click)="saveStorageHold()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="storageReleaseDialogVisible" [modal]="true" [style]="{width: '820px', maxWidth: '96vw'}" styleClass="case-leg-dialog master-case-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-lock-open"></i></span>
      <span><strong>Release Storage Hold</strong><small>Clear the storage exception and return the dwell episode to active control.</small></span>
    </div>
  </ng-template>
  <section class="release-dialog-body compact-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-lock-open"></i></div>
      <div>
        <small>Storage recovery</small>
        <h3>Return dwell to active</h3>
        <p>Clear the storage exception and record the release decision on the lifecycle timeline.</p>
      </div>
      <div class="release-dialog-facts">
        <div><span>Container</span><strong>{{ caseItem?.containerNumber || '-' }}</strong></div>
        <div><span>Facility</span><strong>{{ selectedStorageLeg?.facilityName || '-' }}</strong></div>
      </div>
    </aside>
  <form [formGroup]="storageReleaseForm" class="dialog-form release-dialog-form">
    <div class="dialog-section">
      <div class="dialog-section-title"><i class="pi pi-lock-open"></i><span>Release details</span></div>
    <div class="dialog-form-grid single-dialog-grid">
      <div class="field">
        <p-iftaLabel><p-datePicker inputId="storageReleaseAt" formControlName="eventTime" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker><label for="storageReleaseAt">Event Time</label></p-iftaLabel>
      </div>
      <div class="field">
        <p-iftaLabel><input id="storageReleaseNotes" pInputText formControlName="notes"><label for="storageReleaseNotes">Release Notes</label></p-iftaLabel>
      </div>
    </div>
    </div>
  </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="storageReleaseDialogVisible = false"></p-button>
    <p-button label="Release Hold" icon="pi pi-check" severity="success" (click)="saveStorageRelease()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="storageDialogVisible" [modal]="true" [style]="{width: '1040px', maxWidth: '96vw'}" [breakpoints]="{'960px': '96vw'}" styleClass="case-leg-dialog master-case-dialog release-create-dialog" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="dialog-titlebar">
      <span class="dialog-title-icon"><i class="pi pi-warehouse"></i></span>
      <span>
        <strong>Add Storage Leg</strong>
        <small>Plan full-container dwell, slot assignment context, and storage milestones.</small>
      </span>
    </div>
  </ng-template>
  <section class="release-dialog-body">
    <aside class="release-dialog-summary">
      <div class="summary-icon"><i class="pi pi-box"></i></div>
      <div>
        <small>Storage Episode</small>
        <h3>Planned dwell bridge</h3>
        <p>Use this for confirmed storage planning context. Terminal gate-in and WMS receiving still own live yard visits and stock entries.</p>
      </div>
      <div class="release-dialog-facts">
        <div>
          <span>Container</span>
          <strong>{{ caseItem?.containerNumber || '-' }}</strong>
        </div>
        <div>
          <span>Active Transport</span>
          <strong>{{ activeTransportLeg()?.sequenceNo ? 'Leg ' + activeTransportLeg()?.sequenceNo : 'None' }}</strong>
        </div>
        <div>
          <span>Lifecycle Link</span>
          <strong>Storage leg</strong>
        </div>
      </div>
    </aside>

    <form [formGroup]="storageForm" class="dialog-form release-dialog-form">
      <div class="dialog-section">
        <div class="dialog-section-title"><i class="pi pi-building"></i><span>Facility</span></div>
        <div class="dialog-form-grid">
          <div class="field">
            <p-iftaLabel>
              <p-select inputId="storageType" [options]="storageFacilityOptions" optionLabel="label" optionValue="value" formControlName="facilityType" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full" (onChange)="onStorageFacilityTypeChange()"></p-select>
              <label for="storageType">Facility Type *</label>
            </p-iftaLabel>
          </div>
          <div class="field">
            <p-iftaLabel>
              <p-select inputId="storageFacility" [options]="storageFacilityOptionsForType()" optionLabel="facilityName" optionValue="id" formControlName="facilityId" [filter]="true" filterBy="facilityName,facilityCode" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full" (onChange)="onStorageFacilityChange($event.value)"></p-select>
              <label for="storageFacility">Facility *</label>
            </p-iftaLabel>
          </div>
          <div class="dialog-guidance warning span-2" *ngIf="storageDialogReferenceOnly()">
            <i class="pi pi-info-circle"></i>
            <span>Third-party terminal reference only. CargoMate will keep the terminal on the lifecycle and transport links, but will not manage slots, gate actions, EIR, free time, or charges.</span>
          </div>
          <div class="field" *ngIf="!storageDialogReferenceOnly()">
            <p-iftaLabel>
              <p-select inputId="storageWarehouse" [options]="warehouseOptions" optionLabel="name" optionValue="id" formControlName="warehouseId" [filter]="true" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full"></p-select>
              <label for="storageWarehouse">Linked Warehouse</label>
            </p-iftaLabel>
          </div>
          <div class="field" *ngIf="!storageDialogReferenceOnly()">
            <p-iftaLabel>
              <p-select inputId="storageZone" [options]="storageZoneOptions()" optionLabel="name" optionValue="id" formControlName="zoneId" [filter]="true" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full"></p-select>
              <label for="storageZone">Warehouse Zone</label>
            </p-iftaLabel>
          </div>
        </div>
      </div>

      <div class="dialog-section" *ngIf="!storageDialogReferenceOnly()">
        <div class="dialog-section-title"><i class="pi pi-map"></i><span>Yard Placement</span></div>
        <div class="dialog-form-grid">
          <div class="field">
            <p-iftaLabel>
              <p-select inputId="storageArea" [options]="storageYardAreaOptions()" optionLabel="areaName" optionValue="id" formControlName="yardAreaId" [filter]="true" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full" (onChange)="onStorageAreaChange($event.value)"></p-select>
              <label for="storageArea">Yard Area</label>
            </p-iftaLabel>
          </div>
          <div class="field">
            <p-iftaLabel>
              <p-select inputId="storageSlot" [options]="storageYardSlotOptions()" optionLabel="slotCode" optionValue="id" formControlName="yardSlotId" [filter]="true" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full" (onChange)="onStorageSlotChange($event.value)"></p-select>
              <label for="storageSlot">Yard Slot</label>
            </p-iftaLabel>
          </div>
          <div class="field">
            <p-iftaLabel>
              <p-select inputId="storageReason" [options]="storageReasonOptions" optionLabel="label" optionValue="value" formControlName="storageReason" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full"></p-select>
              <label for="storageReason">Storage Reason</label>
            </p-iftaLabel>
          </div>
          <div class="field">
            <p-iftaLabel>
              <input id="storageSourceRef" pInputText formControlName="sourceReference">
              <label for="storageSourceRef">Source Reference</label>
            </p-iftaLabel>
          </div>
        </div>
      </div>

      <div class="dialog-section">
        <div class="dialog-section-title"><i class="pi pi-arrows-h"></i><span>Transport Bridge</span></div>
        <div class="dialog-form-grid">
          <div class="field">
            <p-iftaLabel>
              <p-select inputId="storageInboundTransport" [options]="transportLegs" optionLabel="sequenceNo" optionValue="id" formControlName="inboundTransportLegId" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full"></p-select>
              <label for="storageInboundTransport">Inbound Transport Leg</label>
            </p-iftaLabel>
          </div>
          <div class="field">
            <p-iftaLabel>
              <p-select inputId="storageOutboundTransport" [options]="transportLegs" optionLabel="sequenceNo" optionValue="id" formControlName="outboundTransportLegId" [showClear]="true" appendTo="body" panelStyleClass="case-select-panel" styleClass="w-full"></p-select>
              <label for="storageOutboundTransport">Outbound Transport Leg</label>
            </p-iftaLabel>
          </div>
        </div>
      </div>

      <div class="dialog-section">
        <div class="dialog-section-title"><i class="pi pi-calendar-clock"></i><span>Storage Window</span></div>
        <div class="dialog-form-grid">
          <div class="field">
            <p-iftaLabel>
              <p-datePicker inputId="storagePlannedIn" formControlName="plannedInAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
              <label for="storagePlannedIn">Planned In</label>
            </p-iftaLabel>
          </div>
          <div class="field">
            <p-iftaLabel>
              <p-datePicker inputId="storagePlannedOut" formControlName="plannedOutAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
              <label for="storagePlannedOut">Planned Out</label>
            </p-iftaLabel>
          </div>
          <div class="field" *ngIf="!storageDialogReferenceOnly()">
            <p-iftaLabel>
              <p-datePicker inputId="storageFreeStart" formControlName="freeTimeStartAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
              <label for="storageFreeStart">Free Time Start</label>
            </p-iftaLabel>
          </div>
          <div class="field" *ngIf="!storageDialogReferenceOnly()">
            <p-iftaLabel>
              <p-datePicker inputId="storageFreeEnd" formControlName="freeTimeEndAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
              <label for="storageFreeEnd">Free Time End</label>
            </p-iftaLabel>
          </div>
          <div class="field" *ngIf="!storageDialogReferenceOnly()">
            <p-iftaLabel>
              <p-datePicker inputId="storageChargeFrom" formControlName="chargeableFromAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
              <label for="storageChargeFrom">Chargeable From</label>
            </p-iftaLabel>
          </div>
          <div class="field" *ngIf="!storageDialogReferenceOnly()">
            <p-iftaLabel>
              <p-datePicker inputId="storageChargeTo" formControlName="chargeableToAt" [showTime]="true" hourFormat="12" appendTo="body" styleClass="w-full"></p-datePicker>
              <label for="storageChargeTo">Chargeable To</label>
            </p-iftaLabel>
          </div>
          <div class="field span-2">
            <p-iftaLabel>
              <textarea id="storageNotes" pTextarea rows="2" formControlName="notes"></textarea>
              <label for="storageNotes">Notes</label>
            </p-iftaLabel>
          </div>
        </div>
      </div>
    </form>
  </section>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="storageDialogVisible = false"></p-button>
    <p-button label="Save Leg" icon="pi pi-check" (click)="saveStorageLeg()" [loading]="isSubmitting"></p-button>
  </ng-template>
</p-dialog>
